import React from 'react';
import SimplerNotify from './SimplerNotify'

export default function NoResults(props) {
  return <SimplerNotify styleName="primary" message=
      {props.displayText ? props.displayText : 
        "There is nothing to show here. Press F5 (Command+R on a Mac) to try again"} />
};
